import { useState } from "react";

export function useHomepageModals() {
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [contactsRefreshCounter, setContactsRefreshCounter] = useState(0);
  const [isAddContactModalOpen, setIsAddContactModalOpen] = useState(false);
  const [isEditContactModalOpen, setIsEditContactModalOpen] = useState(false);
  const [isAddClientModalOpen, setIsAddClientModalOpen] = useState(false);
  const [isEditClientModalOpen, setIsEditClientModalOpen] = useState(false);
  const [isDeleteClientDialogOpen, setIsDeleteClientDialogOpen] = useState(false);
  const [isDeleteContactDialogOpen, setIsDeleteContactDialogOpen] = useState(false);
  const [isUnlinkConfirmOpen, setIsUnlinkConfirmOpen] = useState(false);
  const [isMeetingDeleteDialogOpen, setIsMeetingDeleteDialogOpen] = useState(false);
  const [isDeletingMeeting, setIsDeletingMeeting] = useState(false);
  const [isImportContactModalOpen, setIsImportContactModalOpen] = useState(false);
  const [isOutlookImportOpen, setIsOutlookImportOpen] = useState(false);
  const [returnToLinkMode, setReturnToLinkMode] = useState(false);

  return {
    isLinkModalOpen, setIsLinkModalOpen,
    contactsRefreshCounter, setContactsRefreshCounter,
    isAddContactModalOpen, setIsAddContactModalOpen,
    isEditContactModalOpen, setIsEditContactModalOpen,
    isAddClientModalOpen, setIsAddClientModalOpen,
    isEditClientModalOpen, setIsEditClientModalOpen,
    isDeleteClientDialogOpen, setIsDeleteClientDialogOpen,
    isDeleteContactDialogOpen, setIsDeleteContactDialogOpen,
    isUnlinkConfirmOpen, setIsUnlinkConfirmOpen,
    isMeetingDeleteDialogOpen, setIsMeetingDeleteDialogOpen,
    isDeletingMeeting, setIsDeletingMeeting,
    isImportContactModalOpen, setIsImportContactModalOpen,
    isOutlookImportOpen, setIsOutlookImportOpen,
    returnToLinkMode, setReturnToLinkMode,
  };
}
